export class FilterCountries {
  static readonly type = '[Country-State] Filter Countries';
  constructor() {}
}
